import type { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'
import {
  AttachmentUploadStatusEnum,
  PostAttachmentInterface,
} from 'modules/community/types/post-attachment'

interface EmbeddedVideoPreviewProps {
  className?: string
  attachment: PostAttachmentInterface
}

const EmbeddedVideoPreview = ({ attachment, className }: EmbeddedVideoPreviewProps): ReactNode => {
  return (
    <div
      className={twMerge(
        'size-full overflow-hidden rounded-lg',
        attachment.status === AttachmentUploadStatusEnum.Uploading && `bg-bg-page`,
        className,
      )}
    >
      <img
        className="size-full object-cover"
        src={attachment.previewUrl ?? undefined}
        alt={attachment.previewUrl ?? undefined}
      />
    </div>
  )
}

export default EmbeddedVideoPreview
